import React from 'react';
import { DeliveryTagWrapper } from './listing-tile.style';
import Icon from '../icon/icon';

const DeliveryTag = ({ style }: { style?: React.CSSProperties }) => {
    return (
        <DeliveryTagWrapper style={style}>
            <Icon type="delivery-car" />
            Delivery available
        </DeliveryTagWrapper>
    );
};

export default DeliveryTag;
